import React from "react";
import { useTranslation } from "react-i18next";

/** Material-UI */
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: 8,
        width: "100%",
        fontSize: "clamp(13px, 1vw, 1rem)",
        fontWeight: 600,
        paddingTop: 4,
        textWrap: "pretty",
        "& + &": {},
        [theme.breakpoints.down("sm")]: {
            flexWrap: "wrap",
            gap: 0,
        },
    },
    sublist: {
        width: "100%",
        padding: theme.spacing(0, 0, 0, 0),
    },
    item: {
        fontSize: "clamp(14px, 2vw, 1.25rem)",
        fontWeight: 400,
        "& span": {
            fontWeight: 600,
        },
    },
}));

const Infocard = (props) => {
    let { item, regex, isMobile } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    /** start "api incomplete" 
     * may remove when api is complete (api has the necessary fields)
    */
    const HIDE_NODATA = process.env.REACT_APP_HIDE_NODATA ? JSON.parse(process.env.REACT_APP_HIDE_NODATA) : false;
    item = {
        ...item,
        data_aktualizacji: !item.data_aktualizacji ? (!!HIDE_NODATA ? null : t("Brak danych")) : item.data_aktualizacji,
        forma_prowadzenia_systemu: !item.forma_prowadzenia_systemu
            ? !!HIDE_NODATA
                ? null
                : t("Brak danych")
            : item.forma_prowadzenia_systemu,
        stan_wdrożenia: !item.stan_wdrożenia ? (!!HIDE_NODATA ? null : t("Brak danych")) : item.stan_wdrożenia,
        planowany_termin_wdrożenia: !item.planowany_termin_wdrożenia
            ? !!HIDE_NODATA
                ? null
                : t("Brak danych")
            : item.planowany_termin_wdrożenia,
    };
    /** end "api incomplete" */

    return (
        <>
            <ul className={classes.sublist}>
                <li className={classes.container}>
                    <span className={classes.item} style={{ fontWeight: isMobile ? 500 : undefined }}>
                        {`${item.nazwa_systemu_skr ? item.nazwa_systemu_skr.replace(regex, "") + ", " : ""} ${
                            item.gestor ? item.gestor.replace(regex, "") : ""
                        }`}
                    </span>
                </li>

                {/* {!!item.data_aktualizacji && (
                    <li className={classes.container} style={{ paddingLeft: isMobile ? 16 : undefined }}>
                        <span className={classes.item}>
                            {t("Data aktualizacji")}
                            {":"}&nbsp; <span>{item.data_aktualizacji}</span>
                        </span>
                    </li>
                )} */}

                {/* {!!item.forma_prowadzenia_systemu && (
                    <li className={classes.container} style={{ paddingLeft: isMobile ? 16 : undefined }}>
                        <span className={classes.item}>
                            {t("Forma prowadzenia systemu")}
                            {":"}&nbsp; <span>{item.forma_prowadzenia_systemu}</span>
                        </span>
                    </li>
                )} */}

                {/* {!!item.stan_wdrożenia && (
                    <li className={classes.container} style={{ paddingLeft: isMobile ? 16 : undefined }}>
                        <span className={classes.item}>
                            {t("Stan wdrożenia")}
                            {":"}&nbsp; <span>{item.stan_wdrożenia}</span>
                        </span>
                    </li>
                )} */}

                {/* {!!item.planowany_termin_wdrożenia && (
                    <li className={classes.container} style={{ paddingLeft: isMobile ? 16 : undefined }}>
                        <span className={classes.item}>
                            {t("Planowany termin wdrożenia")}
                            {":"}&nbsp; <span>{item.planowany_termin_wdrożenia}</span>
                        </span>
                    </li>
                )} */}
            </ul>
        </>
    );
};

export default Infocard;
